import React from 'react'
import Sortition from '../sortition';

const InnerTable = ({
    columns,
    options,
    hasSorting,
    handleChange,
    dataList,
    setDataListFromItem,
    customProps, dataListToDisplay, isDynamicColumns, exportDataModel }) => {
    const [colsToShow, setColsToShow] = React.useState([])
    const renderableColumns = () => {

        return colsToShow.filter(item => item.display === true && item.show);
    }
    return (
        <table className="table table-bordered table-table" id="gsfTable">
            <thead>

                <Sortition
                    columns={columns}
                    options={options}
                    hasSorting={hasSorting}
                    setSortText={handleChange}
                    setColsToShow={setColsToShow}
                    colsToShow={colsToShow}
                    isDynamicColumns={isDynamicColumns}
                    exportDataModel={exportDataModel}
                />

            </thead>
            <tbody>

                {dataListToDisplay.map((item, idx) => <tr key={idx}>
                    {renderableColumns().map((column, idx2) => {
                        if (column.component) {
                            return (
                                <td key={idx2}>{column.component({ item, index: idx, dataList, setDataListFromItem, ...customProps })}</td>
                            )
                        } else {
                            let className = '';
                            if (column.rowClassName && Array.isArray(column.rowClassName)) {
                                column.rowClassName.map(_item => {
                                    if (item[_item.property] === _item.value) {
                                        className += _item.className
                                    }
                                })
                            }
                            if (column.display) {
                                return (
                                    <td className={className}
                                        key={idx2}>{item[column.property]}</td>)
                            }
                        }

                    })}
                    {options && <td>
                        {options(item)}
                    </td>}
                </tr>)}
            </tbody>
        </table>
    )
}

export default InnerTable
